module.exports = __webpack_public_path__ + "static/img/animation13.gif";